import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FilledButton, Heading3 } from '@sainsburys-tech/luna-react'
import { buildCategoryOptions } from 'src/utils/buildCategoryOptions'
import keyBy from 'src/utils/keyBy'

import CheckboxGroup from 'src/components/CheckboxGroup'

class CategoriesSelect extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: props.selectedCategories.map(({ id }) => id),
    }
    this.onChange = this.onChange.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
  }

  handleSave() {
    const { save, handleClose } = this.props
    const { value } = this.state
    save(value)
    handleClose()
  }

  handleCancel() {
    const { handleClose } = this.props
    handleClose()
  }

  onChange(value) {
    this.setState({ value })
  }

  render() {
    const { categories, shelfId, selectedCategories } = this.props
    const { value } = this.state
    const input = {
      value,
      onChange: this.onChange,
      name: `${shelfId}-categories`,
    }
    const allUniqueCategories = Object.values(keyBy([...selectedCategories, ...categories], 'id'))
    const options = buildCategoryOptions(allUniqueCategories, 'title')

    return (
      <div>
        <Heading3>Select Categories</Heading3>
        <div className="ln-u-push-bottom u-reset-wrap">
          <CheckboxGroup options={options} input={input} />
        </div>
        <div>
          <FilledButton data-control="save-categories-select" onClick={this.handleSave}>
            Save
          </FilledButton>
          <FilledButton
            color="dark"
            data-control="cancel-categories-select"
            onClick={this.handleCancel}
            className="ln-u-push-left"
          >
            Cancel
          </FilledButton>
        </div>
      </div>
    )
  }
}

const categoryType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
})

CategoriesSelect.propTypes = {
  shelfId: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(categoryType).isRequired,
  selectedCategories: PropTypes.arrayOf(categoryType).isRequired,
  handleClose: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
}

export default CategoriesSelect
